import { UserResponse } from '@townsquare/identity-client';

import { remoteAuthCheck } from './check';

/**
 * Separate file to make mocking easier in tests.
 */
export const prefetchedAuthCheckPromise: Promise<{
    isAuthed: boolean;
    isUnauthenticated: boolean;
    isUnauthorised: boolean;
    isNoUser: boolean;
    user: UserResponse | null;
}> = remoteAuthCheck();
